import React from "react";
import { RiErrorWarningLine } from "react-icons/ri";

const Model = ({
  show,
  close,
  title,
  userResignCount,
  message,
  userDeactiveHandle,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 w-[554px]  rounded-xl shadow-xl  ">
        <div className="flex flex-col items-center  px-7">
          <RiErrorWarningLine className="w-16 h-16 text-[30px] text-orange-600" />
          <div className="flex items-center flex-col gap-8 mt-6">
            <div className="text-lg font-semibold text-gray-900">{title}</div>
            <div className="text-sm  text-gray-900">{message}</div>
          </div>
        </div>

        <div className="flex justify-center gap-6 items-center mt-12">
          <button
            onClick={close}
            className="bg-[#AFAFAF] w-[134px] h-[42px] text-white font-semibold"
          >
            cancel
          </button>
          {userResignCount === 0 ? (
            <>
              <button
                onClick={userDeactiveHandle}
                className="bg-primary w-[134px] h-[42px] text-white font-semibold"
              >
                Deactive
              </button>
            </>
          ) : (
            <>
              <button
                onClick={close}
                className="bg-primary w-[134px] h-[42px] text-white font-semibold"
              >
                Resign
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Model;
